import Lesson from 'models/Lesson';
import { useContext } from 'react';
import LessonContext from './context';

export function useLessons() {
  const { lessons } = useContext(LessonContext);
  return lessons as Lesson[];
}

export function useRefreshData() {
  const { setRefreshData } = useContext(LessonContext);
  return () => setRefreshData(true);
}
